<mat-dialog-content>
  <app-blocks-workflow [blocks]="blocks" [models]="models" [context]="context" (workflowComplete)="onWorkflowComplete($event)"></app-blocks-workflow>
</mat-dialog-content>
